import { render, staticRenderFns } from "./systemDetail.vue?vue&type=template&id=1cd340f8&scoped=true"
import script from "./systemDetail.vue?vue&type=script&lang=js"
export * from "./systemDetail.vue?vue&type=script&lang=js"
import style0 from "./systemDetail.vue?vue&type=style&index=0&id=1cd340f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd340f8",
  null
  
)

export default component.exports